module.exports = __webpack_public_path__ + "static/media/element_dots.02ce7eae.svg";